const formatHours = (str: string): string | null => {
  if (str === '') {
    return '00'
  }
  if (!str.match(/([0-5]|[0-5][0-9])/)) {
    return null
  }
  if (str.length === 1) {
    return '0' + str
  }
  return str
}

const formatMinutes = (str: string): string | null => {
  if (str === '') {
    return '00'
  }
  if (!str.match(/([0-5]|[0-5][0-9])/)) {
    return null
  }
  if (str.length === 1) {
    return str + '0'
  }
  return str
}

const formatTime = (str: string): string | null => {
  if (str === '') {
    return null
  }
  str = str.replace(/[:hH]/, 'h')
  if (
    !str.match(
      /^(([0-9]|([0-1][0-9]|2[0-3]))|(([0-9]|([0-1][0-9]|2[0-3]))[h])|(([0-9]|([0-1][0-9]|2[0-3]))[h]([0-5]|[0-5][0-9])))$/,
    )
  ) {
    return null
  }

  const splittedStr = str.split('h')

  if (splittedStr.length === 1) {
    return formatHours(splittedStr[0]) + 'h00'
  } else if (splittedStr.length === 2) {
    return formatHours(splittedStr[0]) + 'h' + formatMinutes(splittedStr[1])
  }
  return str
}

export { formatTime }
